export const publicRoutes = new Set([
  'LoginView',
  'LogoutPortal',
  'StudentLoginView',
  'StudentLogoutPortal',
  'ExtensionLogoutPortal',
  'CustomTokenLoginPortal',
  'ClassroomAssignmentFormView',
  'Oauth2LoginView',
  'Oauth2LoginWarningView',
  'Oauth2CallbackView',
  'GetCustomTokenView',
  'LoadCustomTokenView',
  'CustomTokenSignInView',
  'CustomTokenAuthView',
  'LearnicsUTermsOfServiceView',
  'LearnicsUTourView',
  'DriveFileSelectView',
  'ExtensionUninstallSuccessView',
  'TeacherTryForFreeRedirectPortal',
  'TeacherTryForFreePortal',
])
